export default {
  block: 'Block',
  blocks: 'Blocks',
  newBlock: 'New Block',
  editBlock: 'Edit Block',
  blockId: 'Block ID',
  blockIdRequired: 'Block ID is required',
  blockIdHelp: 'Unique identifier in the system',
  displayName: 'Display Name',
  displayNameRequired: 'Display name is required',
  displayNameHelp: 'Name to be displayed in the visual interface',

  // Assignment scope
  assignmentScope: 'Add the trips of the route to the selected block',
  onDate: 'On a specific date',
  betweenDates: 'Between dates',
  permanently: 'Permanently',
  endDateMustBeAfterStartDate: 'End date must be after start date',
  selectDateRequired: 'Please select a date',
  selectDaysRequired: 'Please select at least one day',
  selectTripsRequired: 'Please select at least one trip',
  selectBlockRequired: 'Please select a block',

  // Day selection
  selectDays: 'Select Days',
  weekdays: 'Weekdays',

  // Trip selection
  selectTrips: 'Select Trips',
  noTripsAvailable: 'No trips available',
  selectBlock: 'Select Block',
  selectBlockPlaceholder: 'Select a block',
  addBlock: 'Add Block',

  // Assignment preview
  assignmentPreview: 'Assignment Preview',
  noAssignments: 'No assignments yet',
  days: 'Days',
  trips: 'Trips',
  departure: 'Departure',
  currentBlock: 'Current Block',
  newBlockAssignment: 'New Block',

  // Delete confirmation
  deleteBlockTitle: 'Block Deletion Confirmation',
  deleteBlockMessage:
    'There are trips assigned to this block. Please review the assigned trips before proceeding with deletion.',
  deleteBlockConfirm: 'Delete Block',

  // Success/Error messages
  blockCreated: 'Block created successfully',
  blockUpdated: 'Block updated successfully',
  blockDeleted: 'Block deleted successfully',
  blockAssigned: 'Block assigned successfully',
  blockCreateError: 'Error creating block',
  blockUpdateError: 'Error updating block',
  blockDeleteError: 'Error deleting block',
  blockAssignError: 'Error assigning block',
  blockAssignConflict: 'Block assignment conflict detected',
};
